// extracted by mini-css-extract-plugin
module.exports = {"tokens":"\"../../styles/tokens.module.css\"","notblack":"undefined","message":"Empty_message__JzmN0 undefined"};